import React, {
  Suspense,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
// import { Rings } from  'react-loader-spinner'
import pignon from "./pignon.gif";
// import Three from "../../features/three/Three";
import { Link } from "react-router-dom";

// import { ThreeSphere } from "./features/three/SphereV1";
// import styled from "styled-components";

import { useSelector } from "react-redux";
// import { selectSecondeColor } from "../../features/counter/counterSlice";
import { selectSecondeColor } from "../../features/counter/counterSlice";
// import ThreeCard from "../Three/TextReact";
// import Leopard from "../Three/Leopard";
// import Galerie3D from "../Three/Galerie3D";
// import VirtualSpace from "../Three/VirtualSpace";
// import { ThreeSphere } from "../Competences/DossierTestThree/SphereV1";
// import MapContact from "../Contact/Map";
import SvgBackground from "../Background/Svg";
// import Icosahedron from "../Three/Icosahedron";
import BienwenueMessage from "../TypeWriterMessage/BienwenueMessage";
// import CubeSpheres from "../EspaceVirtuel/CubeSpheres";
import CubeSpheresold from "../EspaceVirtuel/CubeSpheresold";
// import { cloneUniforms } from "three";
// import Sample from "../AffichagePDF/Sample.tsx";
// import { Helmet } from 'react-helmet-async';
import axios from "axios";
import Chatbot from "../Chatbot/Chatbot";

const NMIcosahedron = React.lazy(() => import("../Three/Icosahedron"));
const NMLeopard = React.lazy(() => import("../Three/Leopard"));
const NMThreeCard = React.lazy(() => import("../Three/TextReact"));
const NMGalerie3D = React.lazy(() => import("../Three/Galerie3D"));

const Icosahedron = React.memo(NMIcosahedron);
const Leopard = React.memo(NMLeopard);
const ThreeCard = React.memo(NMThreeCard);
const Galerie3D = React.memo(NMGalerie3D);

function Welcome() {
  const mailServer = process.env.MAIL_SERVER;
  // const SvgBackground = React.lazy(() => import("../Background/Svg"));

  const secondeColor = useSelector(selectSecondeColor);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const [recharge, setRecharge] = useState(true);
  const [botchatOpen, setBotchatOpen] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [showFirstSvg, setShowFirstSvg] = useState(!botchatOpen);

  const numImages = 78;

  const svgElementsRef = useRef([]);
  const svgElements = document.querySelectorAll(".svg_anim");
  svgElementsRef.current = Array.from(svgElements);

  useEffect(() => {
    const svgElements = document.querySelectorAll(".svg_anim");
    svgElementsRef.current = Array.from(svgElements);
  }, []);

  useEffect(() => {
    svgElementsRef.current.forEach((element) => {
      element.classList.add("slow");
    });
  }, [recharge]);

  const [phase, setPhase] = useState("idle"); // "idle" | "hiding" | "showing"
  const [showSecond, setShowSecond] = useState(botchatOpen);

  useEffect(() => {
    if (botchatOpen !== showSecond) {
      setPhase("hiding");

      setTimeout(() => {
        setShowSecond(botchatOpen);
        setPhase("showing");

        setTimeout(() => {
          setPhase("idle");
        }, 400); // same duration as .enter
      }, 400); // same duration as .exit
    }
  }, [botchatOpen, showSecond]);

  useEffect(() => {
    setIsTransitioning(true);

    const timer = setTimeout(() => {
      setShowFirstSvg(!botchatOpen);
      setIsTransitioning(false);
    }, 400); // time must match CSS transition

    return () => clearTimeout(timer);
  }, [botchatOpen]);

  function handleButtonClick() {
    window.scrollTo({ top: 0, behavior: "smooth" });

    setIsButtonVisible(false);

    const elements = document.querySelectorAll(".svg_anim");
    elements.forEach((element) => {
      element.classList.add("falling");
    });
    //   const svgElements = document.querySelectorAll(".svg_anim");
    // svgElementsRef.current = Array.from(svgElements);

    CubeSpheresold();
  }

  const handleChildStateChange = useCallback((state) => {
    setRecharge(state);
    // svgElementsRef.current.forEach((element) => {
    //   element.style.transition = "2s cubic-bezier(0, 0, 0.42, 1.46)";
    // });
  }, []);

  const suspence = (
    <div
      style={{
        backgroundImage: `url(${pignon})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "15wv",
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    ></div>
  );

  const FirstSvgBotchat = () => {
    return (
      <svg width="48" height="48" viewBox="0 0 512 512" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          transform="scale(64)"
          fill="#8d8d8d"
        />
        <g transform="translate(100, 120) scale(13)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.601 8.39897C18.269 8.06702 17.7309 8.06702 17.3989 8.39897L12 13.7979L6.60099 8.39897C6.26904 8.06702 5.73086 8.06702 5.39891 8.39897C5.06696 8.73091 5.06696 9.2691 5.39891 9.60105L11.3989 15.601C11.7309 15.933 12.269 15.933 12.601 15.601L18.601 9.60105C18.9329 9.2691 18.9329 8.73091 18.601 8.39897Z"
            fill={`rgb(${secondeColor})`}
          ></path>
        </g>
      </svg>
    );
  };

  const SecondeSvgBotchat = () => {
    return (
      <svg width="48" height="48" viewBox="0 0 512 512" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          transform="scale(64)"
          fill="#8d8d8d"
        />
        <g transform="translate(100, 100) scale(10)">
          <path
            fill={`rgb(${secondeColor})`}
            d="M16,19a6.9908,6.9908,0,0,1-5.833-3.1287l1.666-1.1074a5.0007,5.0007,0,0,0,8.334,0l1.666,1.1074A6.9908,6.9908,0,0,1,16,19Z"
          />
          <path
            fill={`rgb(${secondeColor})`}
            d="M20,8a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,20,8Z"
          />
          <path
            fill={`rgb(${secondeColor})`}
            d="M12,8a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,12,8Z"
          />
          <path
            fill={`rgb(${secondeColor})`}
            d="M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V6a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,6V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V6A3.9988,3.9988,0,0,1,6,2H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
          />
          <rect
            id="_Transparent_Rectangle_"
            data-name="&lt;Transparent Rectangle&gt;"
            class="cls-1"
            width="32"
            height="32"
          />
        </g>
      </svg>
    );
  };

  const [current, setCurrent] = useState("svg1");
  const [animating, setAnimating] = useState(false);
  const [showSvg1, setShowSvg1] = useState(true);

  const handleBotchatOpen = () => {
    if (animating) return;
    setBotchatOpen((prev) => !prev);

    const isSvg1 = current === "svg1";
    const next = isSvg1 ? "svg2" : "svg1";
    const outDir = isSvg1 ? "ccw" : "cw";
    const inDir = isSvg1 ? "ccw" : "cw";

    setAnimating(true);

    const currentSvg = document.getElementById(current);
    currentSvg.classList.add(`animate-out-${outDir}`);

    // Étape 1: attente de la disparition
    setTimeout(() => {
      // Masquer l'ancien
      currentSvg.classList.remove(`visible`, `animate-out-${outDir}`);

      // Préparer le suivant
      setShowSvg1(next === "svg1");
      setCurrent(next);

      // Laisser le DOM mettre à jour le visuel
      setTimeout(() => {
        const nextSvg = document.getElementById(next);
        nextSvg.classList.add(`visible`, `animate-in-${inDir}`);

        // Fin animation entrée
        setTimeout(() => {
          nextSvg.classList.remove(`animate-in-${inDir}`);
          setAnimating(false);
        }, 400);
      }, 0); // petite pause pour déclencher l'entrée proprement
    }, 0);
  };

  return (
    <>
      {/* <title>Mon titre de page</title>
        <meta name="description" content="Ma description de page" /> */}

      <main className="projects-overview">
        <section id="message" className="hello-section">
          <div className="main-message">
            <h3 className="main_message_salut">Salut,</h3>
            <span className="line_vertical">
              <h1 className="big_heading">Je m'appele Dimitri</h1>
              <h2 className="opacity_05">
                <BienwenueMessage onStateChange={handleChildStateChange} />
              </h2>
              <p className="competence-text">Node.js, .NET / React</p>
            </span>

            <Link to="/contact" className="filled-button" title="Contactez-moi">
              <button className="contact-button">
                <span className="bef"></span>
                <span className="text">Contactez-moi</span>
                <span className="pointSpan"> </span>
                <br />
              </button>
              <div className="bord"></div>
            </Link>
          </div>
          <div className="espace-virtuel">
            <div className="virtuel" id="virtuel">
              {isButtonVisible && (
                <div className="filled-button">
                  <button
                    className="contact-button"
                    onClick={handleButtonClick}
                  >
                    <span className="bef"></span>
                    <span className="text">Interdit d'appuyer!</span>
                    <span className="pointSpan"> </span>
                    <br />
                  </button>
                  <div className="bord"></div>
                </div>
              )}
            </div>
          </div>
        </section>
        <section id="techno-projects" className="techno-section">
          <div className="spacer">
            <Suspense fallback={suspence}>
              <Icosahedron />
            </Suspense>

            {/* <Icosahedron /> */}
          </div>
          <div className="main-projects">
            <h2>Projects</h2>
            <div className="project_wrapper">
              <div>
                <a
                  className="leopard_projet"
                  rel="Galerie Léonard"
                  target="Galerie Léonard"
                  href="https://lumfo.com/"
                  title="Galerie Léonard"
                >
                  <div className="span_ligne">
                    <h3 className="nom_projet">Galerie Léonard</h3>
                    <div className="three_div">
                      {/* <Leopard /> */}

                      <Suspense fallback={suspence}>
                        <Leopard />
                      </Suspense>
                    </div>
                  </div>
                </a>
                <a
                  className="galerie_3d_projet"
                  rel="Galerie 3D"
                  target="Galerie 3D"
                  href="https://leo.tessard.pro/public/index.php?3d=bordeaux&place=Place%20de%20la%20Com%C3%A9die&date=20220306_163049"
                  title="Galerie 3D"
                >
                  <div className="span_ligne">
                    <h3 className="nom_projet">Galerie 3D</h3>
                    <div className="three_div">
                      <Suspense fallback={suspence}>
                        <Galerie3D />
                      </Suspense>
                    </div>
                  </div>
                </a>
                <a
                  className="galerie_3d_projet"
                  rel="Click and Collect"
                  target="Click and Collect"
                  href="http://clickandcollect.tessard.pro/"
                  title="Click and Collect"
                >
                  <div className="span_ligne">
                    <h3 className="nom_projet">Click and Collect</h3>
                    <div className="three_div">
                      <img
                        src="./ImgProjets/clickandcollect_min.JPG"
                        alt="Click and Collect"
                        width="200"
                        height="200"
                        title="Click and Collect"
                      />
                    </div>
                  </div>
                </a>
                <a
                  className="galerie_3d_projet"
                  rel="Bibliothèque"
                  target="Bibliothèque"
                  href="https://biblio.tessard.pro"
                  title="Bibliothèque"
                >
                  <div className="span_ligne">
                    <h3 className="nom_projet">Bibliothèque</h3>
                    <div className="three_div">
                      <img
                        src="./ImgProjets/Biblio1_min.JPG"
                        alt="Bibliothèque"
                        width="200"
                        height="200"
                        title="Bibliothèque"
                      />
                    </div>
                  </div>
                </a>
                <a
                  className="galerie_3d_projet"
                  rel="Marvel Quiz"
                  target="Marvel Quiz"
                  href="https://marvel-quiz-6d041.firebaseapp.com/welcome"
                  title="Marvel Quiz"
                >
                  <div className="span_ligne">
                    <h3 className="nom_projet">Marvel Quiz</h3>
                    <div className="three_div">
                      <img
                        src="./ImgProjets/MarvelQuiz_min.JPG"
                        alt="Marvel_quiz"
                        width="200"
                        height="200"
                        title="Marvel_quiz"
                      />
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
        <section id="competences">
          <div className="competences">
            <div className="competence_card">
              <h3>MERN</h3>
              <div className="texte_competence">
                J'ai une forte expertise dans le développement web utilisant le
                stack MERN, y compris la création d'API RESTful avec Express, la
                gestion de bases de données MongoDB, la création d'interfaces
                utilisateur réactives avec React, le développement côté serveur
                avec Node.js et la création d'applications de commerce
                électronique.{" "}
              </div>
            </div>
            <div className="competence_card">
              <h3>NODE.JS & .NET</h3>
              <div className="texte_competence">
                J'ai des compétences dans le développement web côté serveur avec
                Node.js et .NET, y compris la création d'API RESTful, la gestion
                de bases de données SQL et NoSQL et la création d'applications
                performantes et évolutives. J'ai une connaissance approfondie
                des concepts backend, ainsi que des compétences avancées en
                utilisant des outils tels que Express, Socket.IO, Mongoose et
                ASP.NET Core. Je suis également capable de développer des
                applications en temps réel et de les déployer sur des services
                cloud comme AWS et Azure.
              </div>
            </div>
            <div className="competence_card">
              <h3>API RESTful et GraphQL</h3>
              <div className="texte_competence">
                J'ai des competences dans la création d'API RESTful et de
                GraphQL, et j'ai de l'expérience dans l'utilisation de ces
                technologies pour le développement d'applications web évolutives
                et performantes. J'ai une bonne connaissance des concepts de
                base de ces technologies, ainsi que des compétences avancées en
                utilisant des outils tels que Express, Apollo Server et Prisma
                ORM. Je suis également capable de concevoir et de mettre en
                œuvre des schémas de données complexes pour répondre aux besoins
                des applications.
              </div>
            </div>
            <div className="competence_card">
              <h3>ES7, ES10</h3>
              <div className="texte_competence">
                Je suis un développeur JavaScript expérimenté, avec une
                expertise dans les versions les plus récentes de la langue, y
                compris ES6+. J'ai une bonne connaissance des concepts de base
                de JavaScript, ainsi que des compétences avancées en utilisant
                des outils modernes pour le développement web. Je suis capable
                de travailler avec des fonctions fléchées, des classes, des
                modules, des destructurations, des promesses et d'autres
                fonctionnalités de ES6+. En comparaison avec ES5, ES6+ propose
                des améliorations significatives pour rendre le code plus
                lisible, plus facile à comprendre et plus maintenable.
              </div>
            </div>
            <div className="competence_card">
              <h3>REDUX, Zustand</h3>
              <div className="texte_competence">
                Je suis compétent dans le développement d'interfaces utilisateur
                réactives avec React et Redux, et j'ai une expérience pratique
                dans l'utilisation de ces technologies pour créer des
                applications web évolutives et performantes. J'ai une bonne
                connaissance des concepts de base de React et Redux, ainsi que
                des compétences avancées en utilisant les hooks de Redux tels
                que useSelector, useDispatch, useStore, useMemo et useCallback,
                création d'un store pour gérer l'état global des applications.
                Je suis également capable de concevoir et de mettre en œuvre des
                architectures de code efficaces pour améliorer la maintenabilité
                et la scalabilité des applications.
              </div>
            </div>

            {/* <svg id="cone-construction" class="icon flat-color" width="800px" height="800px" fill="#000000" data-name="Flat Color"  version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" >
 <path fill="#ff0" id="primary" d="M21,20H19.83L13.88,3.33a2,2,0,0,0-3.76,0L4.17,20H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z" />
 <polygon id="secondary" points="18.4 16 5.6 16 7.38 11 16.62 11" fill="#f00"/>
</svg> */}
            <div className="three" id="canvasCompetenceThree">
              <Suspense fallback={suspence}>
                <ThreeCard />
              </Suspense>
            </div>
          </div>
        </section>
        {botchatOpen && <Chatbot />}
        <div className="botchat_IA" onClick={handleBotchatOpen}>
          <div className="svg-wrapper">
            <div id="svg1" className={`svg-icon ${showSvg1 ? "visible" : ""}`}>
              <SecondeSvgBotchat />
            </div>

            <div id="svg2" className={`svg-icon ${!showSvg1 ? "visible" : ""}`}>
              <FirstSvgBotchat />
            </div>
          </div>
        </div>

        {/* <Suspense
                        fallback={
                          suspence
                          }
                      > */}
        <SvgBackground numImages={numImages} relance={recharge} />
        {/* </Suspense> */}
      </main>
    </>
  );
}

export default Welcome;
